import {clone} from '@formkit/utils'

export const stateAttrsPlugin = (node) => {
	node.on('created', () => {
		const definition = clone(node.props.definition)
		const originalSchema = definition.schema
		definition.schema = (extensions = {}) => {
			// @ts-ignore
			extensions.outer = {
				attrs: {
					'data-blurred': '$state.blurred || undefined',
					'data-dirty': '$state.dirty || undefined',
					// etc...
				}
			}
			return originalSchema(extensions)
		}

		node.props.definition = definition
	})
}
